import {
  PaymentScheduleTypes,
  RelativePeriodOptions
} from "@outschool/gql-backend-generated";
import * as Time from "@outschool/time";
import { dayjs } from "@outschool/time";

export {
  PaymentScheduleTypes,
  RelativePeriodOptions,
  PaymentScheduleStatus,
  ScheduledPaymentLineItemType
} from "@outschool/gql-backend-generated";

export function isRelativePeriod(inStr: any): inStr is RelativePeriodOptions {
  return Object.values(RelativePeriodOptions).includes(inStr);
}

export function isPaymentScheduleType(
  scheduleType: any
): scheduleType is PaymentScheduleTypes {
  return Object.values(PaymentScheduleTypes).includes(scheduleType);
}

function getInitialTime(
  initialTime: dayjs.Dayjs,
  scheduleType: PaymentScheduleTypes,
  relativePeriod: RelativePeriodOptions
) {
  const unit = scheduleType === PaymentScheduleTypes.WeeklySunday ? "w" : "M";
  switch (relativePeriod) {
    case RelativePeriodOptions.Previous:
      return initialTime.subtract(1, unit);
    case RelativePeriodOptions.Current:
      return initialTime;
    case RelativePeriodOptions.Next:
      return initialTime.add(1, unit);
  }
}

export type Period = Record<PaymentScheduleTypes, [Date, Date]>;

export function getPeriod(
  relativePeriod: RelativePeriodOptions,
  initialTime: dayjs.Dayjs | Date = dayjs()
): Period {
  const initialTimeWeekly = getInitialTime(
    dayjs(initialTime),
    PaymentScheduleTypes.WeeklySunday,
    relativePeriod
  );
  const initialTimeMonthly = getInitialTime(
    dayjs(initialTime),
    PaymentScheduleTypes.MonthlyFirst,
    relativePeriod
  );
  return {
    [PaymentScheduleTypes.WeeklySunday]: [
      Time.startOfIsoWeekUtc(initialTimeWeekly),
      Time.endOfIsoWeekUtc(initialTimeWeekly)
    ],
    [PaymentScheduleTypes.MonthlyFirst]: [
      Time.startOfIsoMonthUtc(initialTimeMonthly),
      Time.endOfIsoMonthUtc(initialTimeMonthly)
    ]
  };
}

export function getPeriodForDate(
  date: Date,
  scheduleType: PaymentScheduleTypes
) {
  switch (scheduleType) {
    case PaymentScheduleTypes.MonthlyFirst:
      return [Time.startOfIsoMonthUtc(date), Time.endOfIsoMonthUtc(date)];
    case PaymentScheduleTypes.WeeklySunday:
      return [Time.startOfIsoWeekUtc(date), Time.endOfIsoWeekUtc(date)];
  }
}
